import script from "./StudentLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentLayout.vue?vue&type=script&setup=true&lang=js"

import "./StudentLayout.vue?vue&type=style&index=0&id=681ef0c3&lang=scss&scoped=true"

import exportComponent from "/Users/chronosme/Domains/mathgs2.mu/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-681ef0c3"]])

export default __exports__